// extracted by mini-css-extract-plugin
export default {"container":"NoAvailableChallengesPage_container__Cb8o1","duo-image":"NoAvailableChallengesPage_duo-image__to+Wp"};